import { Box, Radio, SxProps, Typography } from '@mui/material';
import { FC } from 'react';
import { Contact } from '~/api/types';
import EmailIcon from '@mui/icons-material/MailOutline';
import WhatsappIcon from '@mui/icons-material/WhatsApp';
import { colors } from '~/theme';

const ButtonSx: SxProps = {
  'my': 1,
  'py': 2,
  'px': 3,
  'mx': 'auto',
  'backgroundColor': colors.lightGray,
  'display': 'flex',
  'justifyContent': 'space-between',
  'alignItems': 'center',
  'cursor': 'pointer',
  '&:hover': {
    backgroundColor: '#ebe8e8',
  },
};

const LabelSx: SxProps = {
  textAlign: 'left',
  display: 'flex',
  alignItems: 'center',
  maxWidth: 'calc(100% - 50px)',
};

const TitleSx = {
  ml: 2,
  fontSize: { xs: 13, md: 14 },
  wordWrap: 'break-word',
  overflow: 'hidden',
};

export const ContactSelectionButton: FC<ContactSelectionButtonProps> = ({ contact, onClick, selected }) => {
  const Icon = contact.type === 'email' ? EmailIcon : WhatsappIcon;

  return (
    <Box sx={ButtonSx} onClick={onClick}>
      <Box sx={LabelSx}>
        <Icon sx={{ color: colors.disabledGray }} />
        <Typography sx={TitleSx}>{contact.maskedValue}</Typography>
      </Box>
      <Box>
        <Radio color="primary" checked={selected} />
      </Box>
    </Box>
  );
};

export interface ContactSelectionButtonProps {
  contact: Contact;
  onClick: () => void;
  selected: boolean;
}
